'use client';
import React from 'react';
import * as Modal from '@radix-ui/react-dialog';
import cn from 'classnames';
import styles from './simpledialog.module.sass';
import { Button } from '@intigral/shared';
import withPresetWidth from '@intigral/shared/components/hocs/withPresetWidth/withPresetWidth';
import { ResponsivePlacement } from '@intigral/shared/components/hocs/ResponiseStyles/withResponsiveStyles';

interface SimpleDialogProps {
    children: React.ReactNode;
    open: boolean;
    onOpenChange: () => void;
    lbClose: string;
    isInverse?: boolean;
    picture?: string | React.ReactNode;
    placement?: 'center' | 'bottom'; // | ResponsivePlacement;
    presetWidth?: 'small' | 'medium' | 'large' | 'fullPage';
}

// Wrap the Modal.Content with withPresetWidth HOC
const WidthModal = withPresetWidth(Modal.Content);

export const SimpleDialog = ({
    children,
    open,
    onOpenChange,
    lbClose,
    isInverse,
    placement,
    picture,
    presetWidth = 'medium',
}: SimpleDialogProps) => (
    <Modal.Root open={open} onOpenChange={onOpenChange}>
        <Modal.Portal>
            <Modal.Overlay className={cn(styles.overlay, placement && styles[`placement-${placement}`])}>
                <WidthModal className={styles.content} presetWidth={presetWidth}>
                    {picture && (
                        <div className={styles.picture}>
                            {typeof picture === 'string' ? <img src={picture} /> : picture}
                        </div>
                    )}
                    {children && <div className={styles.scrollableContent}>{children}</div>}
                    <Modal.Close asChild>
                        {!isInverse ? (
                            <Button fullWidth>{lbClose}</Button>
                        ) : (
                            <Button fullWidth inverse>
                                {lbClose}
                            </Button>
                        )}
                    </Modal.Close>
                </WidthModal>
            </Modal.Overlay>
        </Modal.Portal>
    </Modal.Root>
);
